import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const MetamaskIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <g fill="#000" clipPath="url(#a)">
      <path d="m18.66 14.11-1.06 3.5-3.58-1.03-.28-.09-.41-.12-1.76-.5-.15.01-.06.22 2.17.62-2.57 1.5H9.04l-2.56-1.5 2.16-.62-.06-.22-.15-.02-2.17.63-.28.09-3.57 1.04-1.07-3.5-.34-.14 1.21 3.98 3.9-1.13 2.85 1.67h2.08l2.86-1.67 3.89 1.13L19 13.98z" />
      <path d="M5.98 14.11v2.47l.28-.09v-2.23l2.17 1.6.15.02.14-.15-2.55-1.9H1.34l1.08-3.95-.26-.14L1 13.98l.34.13zm8.92-2.22-.92.22v.3l1.35-.33.01-2.2h-.19l-.1-.07v1.83l-1.11-1.03h-2.3l-.05.29h2.23z" />
      <path d="M6.02 12.4v-.29l-.92-.22 1.08-1H8.4l-.05-.28H6.12l-.1.04-1.07.99V9.81l-.1.07h-.2l.02 2.2zm11.56-2.52 1.08 3.95h-4.83l-2.55 1.9.14.15.15-.02 2.17-1.6v2.23l.28.09V14.1h4.64l.34-.13-1.16-4.24z" />
      <path d="M4.66 9.88h.19l.1-.07 2.97-2 .45 2.8.04.29.7 4.41.25-.1h.02l-1.2-7.64.22-2.24h3.2l.23 2.24-1.21 7.64h.02l.25.1.7-4.41.05-.28.44-2.8 2.97 2 .1.06h2.43l.26-.14L19 6.16 17.78 1.5 11.7 5.05H8.3L2.22 1.5 1 6.16l1.16 3.58.26.14zM18.7 6.15 17.6 9.6h-2.35L12.2 7.55 17.62 2zm-1.84-3.78-4.77 4.88-.2-1.98zm-8.75 2.9-.2 1.98-4.77-4.88zm-6.81.88L2.38 2l5.43 5.55L4.76 9.6H2.4z" />
      <path d="M10.8 15.21H9.2l-.62.67.3 1.1h2.23l.31-1.1zm.1 1.49H9.1l-.2-.74.41-.46h1.36l.42.46zM8.4 12.82l-.03-.07-.47-1.21H6.62l-.6.57v.3l2.12.5zm-1.67-1h.97l.3.77-1.66-.4zm5.12 1.1 2.12-.52v-.29l-.6-.57h-1.29l-.47 1.2-.03.08zm1.79-.73-1.67.4.3-.77h.98z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M1 1.5h18v17H1z" />
      </clipPath>
    </defs>
  </svg>
);
